import { getBiggerDateArray } from "./initializerHelpers";
import { outrosColors, playerIdColors } from "./playerColors";

const newColorsVC = { ...playerIdColors, OUTROS: outrosColors };

const randomColorIndexStart = 1;
const randomColorIndexEnd = newColorsVC['OUTROS'].length - 1;
let currentColorIndex = randomColorIndexStart;

const idColorMap = {};
const getColorForId = (id) => {
  const key = `id-${id}`;
  const othersColor = newColorsVC['OUTROS'][0];
  if (!idColorMap[key]) {
    if(newColorsVC[key]){
      idColorMap[key] = newColorsVC[key].color;
    } else if (currentColorIndex > randomColorIndexEnd) {
      idColorMap[key] = othersColor;
    } else if(newColorsVC['OUTROS'][currentColorIndex]){
      idColorMap[key] = newColorsVC['OUTROS'][currentColorIndex].color;
      currentColorIndex++;
    } else{
      idColorMap[key] = othersColor;
    }
  }
  return idColorMap[key];
};

export const makeDatasetForSellOut = (pesquisas) => {
  const mapped = [...pesquisas];

  mapped.forEach(e => {
    const color = getColorForId(e.pesquisaPlayerId);
    e.borderColor = color;
    e.backgroundColor = color;
    return e;
  });

  return mapped;
};

const baseLegendSellOutCounter = (pesquisas) => {
  const counter = {};
  for (const pesquisa of pesquisas) {
    const legend = `${pesquisa.player} - ${pesquisa.grupoProduto} - ${pesquisa.label}`;
    if (!counter[legend]) counter[legend] = 0;
    counter[legend] = counter[legend] + 1;
  }
  return counter;
}

export const makeDatasetForSellOutLegendaNew = (pesquisas) => {
  const counter = baseLegendSellOutCounter(pesquisas);

  const legendas = pesquisas.map((e) => {
    const colorEntry = Object.values(newColorsVC).find(colorItem => colorItem.id === e.pesquisaPlayerId);
    const color = colorEntry ? colorEntry.color : getColorForId(e.pesquisaPlayerId);
    let name = `${e.player} - ${e.grupoProduto} - ${e.label}`;
    if (counter[name] !== 1)
      name = `${name} - ${e.embalagemNome}`;
    return [name, color];
  })
  return legendas;
}

export const makeDatasetClientShareLegendaNew = (pesquisas) => {
  const legendas = pesquisas.map((e) => {
    const colorEntry = Object.values(newColorsVC).find(colorItem => colorItem.id === e.id);
    const color = colorEntry ? colorEntry.color : getColorForId(e.id);
    const name = e.label;
    return [name, color];
  })
  return legendas;
}

export const makeDatasetForSellOutLegenda = (pesquisas) => {
  const seen = new Set();
  const first = pesquisas.length > 0 ? pesquisas[0] : null;

  if (!first) return [];

  const { lastDate } = getBiggerDateArray({ data: first.dates });
  
  const checkPack = (pesquisas ?? []).reduce((acc, el) => {
    const indexOfLastDate = el.dates.indexOf(lastDate);
    const dataValue = el.data[indexOfLastDate];
  
    if (!dataValue) return acc;
  
    const key = `${el.player} - ${el.grupoProduto} - ${el.label}`;
  
    acc[key] ??= {};
    acc[key][el.embalagem] ??= [];
    acc[key][el.embalagem].push(el);
  
    return acc;
  }, {});
  
  const dataset = (pesquisas ?? []).reduce((acc, el) => {
    const indexOfLastDate = el.dates.indexOf(lastDate);

    // Verifica se há dados válidos para o índice
    if (!el.data[indexOfLastDate]) return acc;

    const color = getColorForId(el.pesquisaPlayerId);

    const label = `${el?.player} - ${el?.grupoProduto} - ${el?.label}`;
    const keyPack = `${el?.player} - ${el?.grupoProduto} - ${el?.label} - ${el?.embalagem}`;

    const finalLabel = checkPack[label] && Object.keys(checkPack[label])?.length > 1 ? keyPack : label;

    // Verifica se já foi adicionado
    if (el.data.filter(e => e && e != "").length > 0 && !seen.has(finalLabel)) {
      seen.add(finalLabel);
      acc.push([finalLabel, color]);
    }

    return acc;
  }, []);


  return dataset;
};

export const makeDatasetForSellOutLegendaRoteirizacao = (pesquisas, produtos) => {
  const seen = new Set();
  const dataset = (pesquisas || []).reduce((acc, el) => {
    // Acessando diretamente as cores em newColorsVC usando playerID como chave
    const color = getColorForId(el.pesquisaPlayerId);
    const label = `${el?.grupoProduto}`;

    // Verificando se o label já foi adicionado
    if (!seen.has(label)) {
      seen.add(label);
      acc.push([label, color]);
    }

    return acc;
  }, []);

  return dataset;
};


export const makeDatasetForClientShareCharts = (pesquisas = [], tipo = "ClientShare") => {
  let mapped = [...pesquisas];
  mapped = mapped.filter(e => e.data.filter(d => d && d != "").length > 0).map(e => {
    const color = getColorForId(e.id);
    e.backgroundColor = color;

    return e;
  });

  switch (tipo) {
    case "ClientShare":
      return mapped;
    case "legenda":
      return mapped.map(e => {
        return [
          `${e.label}`,
          e.backgroundColor
        ];
      });
  }
};
export const makeDatasetForClientShareChartsRoteirizacao = (pesquisas, tipo = "ClientShare") => {
  const mapped = [...pesquisas];
  mapped.forEach(e => {
    const color = getColorForId(e.id);
    e.backgroundColor = color;
    return e;
  });

  switch (tipo) {
    case "ClientShare":
      return mapped;
    case "legenda":
      return mapped.map(e => {
        return [
          `${e.grupoProduto}`,
          e.backgroundColor
        ];
      });
  }
};
